import { FunctionComponent } from "react";
import RiskToleranceCard from "./RiskToleranceCard";
import { riskToleranceLevelConfig } from "./riskToleranceLevelConfig";
import { Level, CardConfig } from "./@types";
import styles from "./paranoid-mode.module.scss";

interface ParanoidModeProps {
  currentLevel: Level;
  selectedLevel?: Level;
  setSelectedLevel?: (newSelectedLevel: Level) => void;
  isConfigurable?: boolean;
  enabledComponents?: CardConfig;
}

const ParanoidMode: FunctionComponent<ParanoidModeProps> = ({
  currentLevel,
  isConfigurable = false,
  selectedLevel,
  setSelectedLevel,
  enabledComponents
}) => {
  const cards = riskToleranceLevelConfig.map(desc => (
    <RiskToleranceCard
      key={`${desc.level}-${desc.id}`}
      currentLevel={currentLevel}
      isConfigurable={isConfigurable && desc.level !== 0}
      isSelectable={isConfigurable}
      isSelected={(selectedLevel ?? currentLevel) === desc.level}
      setSelectedLevel={setSelectedLevel}
      descriptionProps={desc}
      enabledComponents={enabledComponents}
    />
  ));
  return <div className={styles.options}>{cards}</div>;
};
export default ParanoidMode;
